import {
  GET_EMAIL_SETTINGS_REQUEST,
  GET_EMAIL_SETTINGS_SUCCESS,
  GET_EMAIL_SETTINGS_FAILURE,
  CREATE_EMAIL_SETTINGS_REQUEST,
  CREATE_EMAIL_SETTINGS_SUCCESS,
  CREATE_EMAIL_SETTINGS_FAILURE,
  UPDATE_EMAIL_SETTINGS_REQUEST,
  UPDATE_EMAIL_SETTINGS_SUCCESS,
  UPDATE_EMAIL_SETTINGS_FAILURE,
  DELETE_EMAIL_SETTINGS_REQUEST,
  DELETE_EMAIL_SETTINGS_SUCCESS,
  DELETE_EMAIL_SETTINGS_FAILURE,
  SEND_TEST_EMAIL_REQUEST,
  SEND_TEST_EMAIL_SUCCESS,
  SEND_TEST_EMAIL_FAILURE,
  GMAIL_CONNECT_REQUEST,
  GMAIL_CONNECT_SUCCESS,
  GMAIL_CONNECT_FAILURE,
  GMAIL_CALLBACK_REQUEST,
  GMAIL_CALLBACK_SUCCESS,
  GMAIL_CALLBACK_FAILURE,
} from '../actions/emailActions';

const initialState = {
  emailData: null,
  loading: false,
  saving: false,
  deleting: false,
  sendingTestEmail: false,
  gmailConnecting: false,
  gmailAuthUrl: null,
  gmailConnected: false,
  error: null,
  validationErrors: null,
  lastMessage: null,
};

const emailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        emailData: action.payload,
        error: null,
      };

    case GET_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case CREATE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null,
      };

    case CREATE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        saving: false,
        emailData: action.payload.data,
        lastMessage: action.payload.message,
        error: null,
      };

    case CREATE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error,
        validationErrors: action.validationErrors,
      };

    case UPDATE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null,
      };

    case UPDATE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        saving: false,
        emailData: action.payload.data,
        lastMessage: action.payload.message,
        error: null,
      };

    case UPDATE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error,
        validationErrors: action.validationErrors,
      };

    case DELETE_EMAIL_SETTINGS_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
        lastMessage: null,
      };

    case DELETE_EMAIL_SETTINGS_SUCCESS:
      return {
        ...state,
        deleting: false,
        emailData: null,
        lastMessage: action.payload.message,
        error: null,
      };

    case DELETE_EMAIL_SETTINGS_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.error,
      };

    case SEND_TEST_EMAIL_REQUEST:
      return {
        ...state,
        sendingTestEmail: true,
        error: null,
      };

    case SEND_TEST_EMAIL_SUCCESS:
      return {
        ...state,
        sendingTestEmail: false,
        error: null,
      };

    case SEND_TEST_EMAIL_FAILURE:
      return {
        ...state,
        sendingTestEmail: false,
        error: action.error,
      };

    // Gmail connect flow
    case GMAIL_CONNECT_REQUEST:
      return {
        ...state,
        gmailConnecting: true,
        error: null,
      };
    case GMAIL_CONNECT_SUCCESS:
      return {
        ...state,
        gmailConnecting: false,
        gmailAuthUrl: action.payload?.url || null,
        error: null,
      };
    case GMAIL_CONNECT_FAILURE:
      return {
        ...state,
        gmailConnecting: false,
        error: action.error,
      };

    case GMAIL_CALLBACK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GMAIL_CALLBACK_SUCCESS:
      return {
        ...state,
        loading: false,
        gmailConnected: !!action.payload?.data?.hasRefreshToken,
        error: null,
      };
    case GMAIL_CALLBACK_FAILURE:
      return {
        ...state,
        loading: false,
        gmailConnected: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default emailReducer;
